module.exports = __webpack_public_path__ + "img/CompScope_Space_08.a12e33ce.png";